const billingDomains: { [key: string]: string; } = {
    'angarsk': 'irkutsk',
    'vlz': 'volgograd',
    'kazan': 'kzn',
    'kungur': 'perm',
    'mich': 'lipetsk',
    'nk': 'chelny',
    'dzr': 'nn',
    'syzran': 'samara',
    'interzet': 'spb',
    'seversk': 'tomsk',
    'ulu': 'irkutsk',
    'usol': 'irkutsk',
    'yats': 'yar',
    'slk': 'perm',
    'ber': 'perm'
};

export default billingDomains;
